module.exports = __webpack_public_path__ + "img/note-remove.c9323084.svg";